import original1 from "./original-1";
import original2 from "./original-2";
import original3 from "./original-3";
import original4 from "./original-4";
import original5 from "./original-5";

original1();
original2();
original3();
original4();
original5();